const options = {
  5: "bg-rose-500/5",
  10: "bg-rose-500/10",
  25: "bg-rose-500/25",
  50: "bg-rose-500/50",
  75: "bg-rose-500/75",
  90: "bg-rose-500/90",
  100: "bg-rose-500",
};

const from = {
  5: "from-rose-500/5",
  10: "from-rose-500/10",
  25: "from-rose-500/25",
  50: "from-rose-500/50",
  75: "from-rose-500/75",
  90: "from-rose-500/90",
  100: "from-rose-500",
};

export default function getBackgroundRose500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
